import React, { useState, useEffect } from 'react';
import { IconButton, Dialog, Typography, DialogTitle, DialogContent, Box, DialogActions, Button, Avatar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { UserInfo } from '../../../interfaces/ProfileInfo';
import { BioModalProps } from '../../../interfaces/BioModal';
import { useTranslation } from 'react-i18next';
import { PinnerProIcon } from '../../../assets/icons/Index';
import { getConfig } from '../../../config/env';

const BioModal: React.FC<BioModalProps> = ({ open, onClose, userId, isPinnerPro }) => {
    const url = getConfig().BASE_URL;
    const { t } = useTranslation();
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

    useEffect(() => {
        if (open) {
            axios
                .get(`${url}/users/${userId}/`)
                .then((response) => {
                    setUserInfo(response.data);
                })
                .catch((error) => {
                    console.error('Errore nel recupero dei dati utente:', error);
                });
        }
    }, [open, userId]);

    return (
        <Dialog
            fullWidth
            open={open}
            maxWidth="sm"
            onClose={onClose}
            PaperProps={{ style: { backgroundColor: '#ffffff' } }}
        >
            <DialogTitle>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ position: 'relative' }}>
                        <Avatar
                            src={userInfo?.profile_picture || 'placeholder.svg'}
                            alt={userInfo?.first_name}
                            style={{ width: '3rem', height: '3rem', borderRadius: '50%', marginRight: '1rem' }}
                        />
                        {isPinnerPro && (
                            <div style={{ position: 'absolute', bottom: -2, right: 9, zIndex: 10 }}>
                                <PinnerProIcon className='' width={21} height={21} />
                            </div>
                        )}
                    </div>
                    <Typography variant="h5">{userInfo?.first_name}</Typography>
                </div>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ maxWidth: '100%', overflowX: 'hidden' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Typography variant="body1">
                        {userInfo?.bio || 'Nessuna biografia disponibile.'}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    sx={{ margin: '1rem', fontSize: { xs: '0.875rem', sm: '1rem' }, backgroundColor: 'transparent', color: '#475467', border: '1px solid #667085' }}
                    fullWidth
                >
                    {t('common:close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BioModal;
